import {useContext} from 'react';
import SettingsContext from 'src/contexts/settingsContext';
import type {SettingsContextValue} from 'src/contexts/settingsContext';

const useSettings = (): SettingsContextValue => useContext(SettingsContext);

export default useSettings;
